import { WalletAddress } from '../Ether';
import { FollowRelationship } from './Follows';
import { GameMultimediaUrls, GemType } from './Game';
import { GemzUser } from './User';

export interface GameLikeUserSchema {
  user_id: string;
  user_username: string;
  user_image: string;
  user_wallet_address: WalletAddress;
  user_displayname: string;
}

export interface GameLikeGameSchema {
  offchain_game_id: string;
  game_onchain_game_id: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  game_multimedia_urls: Record<string, any>;
  game_gem_name: string;
  game_gem_icon: string;
  game_gem_type: string;
  game_created_at: string;
  game_creator_image: string;
  game_creator_wallet_address: WalletAddress;
  game_creator_username: string;
  game_creator_displayname: string;
}

export interface GameLikeGameData {
  offChainGameId: number;
  onChainGameId: number;
  thumbnails: GameMultimediaUrls;
  gemName: string;
  gemIcon: string;
  gemType: GemType;
  purchaseDate: number;
  creatorImage: string;
  creatorWalletAddress: string;
  creatorUsername: string;
  creatorDisplayName: string;
}

export interface GameLikeSchema {
  user_id: string;
  offchain_game_id: string;
  created_at: string;
  relationship?: FollowRelationship;
  relation_to?: string;
}

export interface GameLikeData {
  userId: string;
  gameId: string;
  createdAt: number;
  relationship?: FollowRelationship;
  relationTo?: string;
  user?: Partial<GemzUser>;
  game?: GameLikeGameData;
}

export const getUserFromGameLikeUserSchema = (schema: GameLikeUserSchema): Partial<GemzUser> => ({
  id: Number(schema.user_id),
  username: schema.user_username,
  twitter: {
    handle: schema.user_username,
    displayName: schema.user_displayname,
    picture: schema.user_image,
  },
  walletAddress: schema.user_wallet_address,
});

export const getGameFromGameLikeGameSchema = (schema: GameLikeGameSchema): GameLikeGameData => ({
  offChainGameId: Number(schema.offchain_game_id),
  onChainGameId: Number(schema.game_onchain_game_id),
  thumbnails: schema.game_multimedia_urls as GameMultimediaUrls,
  gemName: schema.game_gem_name,
  gemIcon: schema.game_gem_icon,
  gemType: schema.game_gem_type as GemType,
  purchaseDate: Number(schema.game_created_at),
  creatorImage: schema.game_creator_image,
  creatorWalletAddress: schema.game_creator_wallet_address,
  creatorUsername: schema.game_creator_username,
  creatorDisplayName: schema.game_creator_displayname,
});

export const getGameLikeDataFromSchema = (
  schema: GameLikeSchema,
  extra?: {
    userData?: Partial<GemzUser>,
    userSchema?: GameLikeUserSchema,
    gameData?: GameLikeGameData,
    gameSchema?: GameLikeGameSchema,
  },
): GameLikeData => ({
  userId: schema.user_id,
  gameId: schema.offchain_game_id,
  createdAt: Number(schema.created_at),
  relationship: schema.relationship,
  relationTo: schema.relation_to,
  user: extra?.userData ?? (extra?.userSchema ? getUserFromGameLikeUserSchema(extra.userSchema) : undefined),
  game: extra?.gameData ?? (extra?.gameSchema ? getGameFromGameLikeGameSchema(extra.gameSchema) : undefined),
});
